import { baseUrl } from '../../../boot/index.js';
import axios from 'axios';
export const createBilling = async (data) => {
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/create-billing`, data)
    console.log({ response })
    return response

  } catch (error) {
    console.log({ error })
  }
}

export const deleteBilling = async (ROWID) => {
    console.log({ROWID})
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.delete(`${baseUrl}cleaningappfunctions/finance/app/v1/delete-billing/${ROWID}`, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      console.log("Error is - ",error)
      throw error
    }
  }
export const getProposalById = async (id) => {
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/crm/app/v1/get-proposal-by-id/${id}`)
    console.log({ response })
    return response

  } catch (error) {
    console.log({ error })
  }
}
export const updateBilling = async (data, ROWID) => {
  console.log({ data })
  try {
    const response = await axios.put(`${baseUrl}cleaningappfunctions/finance/app/v1/update-billing/${ROWID}`, data)
    console.log({ response })
    return response

  } catch (error) {
    console.log({ error })
  }
}





export const countBilling = async (formData) => {
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/getcount-billing`, formData, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      throw error
    }
  }



  export const getBillingById = async (id) => {
    const token = localStorage.getItem("authToken")
    try {
      const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/gebyid-billing/${id}`, {
        headers: {
          "auth-token": token,
        }
      },)
      return response;
    } catch (error) {
      throw error
    }
  }